const identifyMarketoLead = (user) => {
  const munchkinHash = user.marketo_munchkin_hash;
  if (munchkinHash) {
    const data = {
      Email: user.email,
      unique_id: user.unique_id,
      FirstName: user.first_name,
      LastName: user.last_name,
    };
    window?.Munchkin?.munchkinFunction("associateLead", data, munchkinHash);
  }
  return new Promise((resolve) => setTimeout(resolve, 500)); // Give Marketo a chance to run before resolving
};

export default identifyMarketoLead;
